import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScoreBarTypes from '../../constants/ScoreBarTypes';
import ScoreBarNG from '../ScoreBarNG/ScoreBarNG';
import style from './style/appendixscorebarsection.scss'; // eslint-disable-line

export default class AppendixScoreBarSection extends Component {
    render() {
        const {
            scoreMin,
            scoreMax,
            scoreValue,
            lowLabel,
            highLabel,
            scoreBarConfig,
            scoreName,
            classes,
            scoreBarType,
            displayScore,
            languageId,
            developabilityLabel,
            developabilityScore,
            developabilityDefinition,
            initials,
            levelRanges
        } = this.props;

        let scoreBar = null;

        // todo: this switch should no longer be needed, since scoreBarNG handles that

        if (scoreBarType) {
            switch (scoreBarType) {
                case ScoreBarTypes.BAR_GRAPH:

                    scoreBar = <ScoreBarNG
                        classes={{
                            barGraph: classes.barGraph,
                            displayScore: classes.displayScore,
                            categoryScore: classes.categoryScore
                        }}
                        scoreValue={ scoreValue }
                        scoreName={ scoreName }
                        displayScore={ displayScore }
                        scoreBarConfig={ scoreBarConfig }
                        scoreBarType={ scoreBarType }
                        fill={ false }
                    />;
                    break;

                case ScoreBarTypes.NORMAL:
                    scoreBar = <ScoreBarNG
                        classes={{
                            root: `${style.scoreBar} ${classes.scoreBar}`,
                            fill: classes.fill,
                            blank: classes.blank,
                            scoreBar: classes.scoreBar,
                            halfScoreFilling: classes.halfScoreFilling,
                            titleWrapper: classes.titleWrapper
                        }}
                        scoreMin={ scoreMin }
                        scoreMax={ scoreMax }
                        scoreValue={ scoreValue }
                        displayScore={ displayScore }
                        config={ scoreBarConfig }
                        scoreName={ scoreName }
                        scoreBarType={ scoreBarType }
                        fill={ false }
                        languageId={ languageId }
                        developabilityLabel={ developabilityLabel }
                        developabilityScore={ developabilityScore }
                        developabilityDefinition={ developabilityDefinition }
                    />;
                    break;

                case ScoreBarTypes.GAUGE:

                    scoreBar = <ScoreBarNG
                        classes={{
                            root: classes.root,
                            colors: classes.colors
                        }}
                        scoreMin={ scoreMin }
                        scoreMax={ scoreMax }
                        scoreValue={ scoreValue }
                        displayScore={ displayScore }
                        config={ scoreBarConfig }
                        scoreName={ scoreName }
                        scoreBarType={ scoreBarType }
                        fill={ false }
                        languageId={ languageId }
                        initials={ initials }
                        levelRanges={ levelRanges }
                    />;
                    break;

                case ScoreBarTypes.CROISSANT:
                default:
                    scoreBar = <ScoreBarNG
                        classes={{
                            fill: classes.fill,
                            blank: classes.blank,
                            scoreBar: classes.scoreBar,
                            halfScoreFilling: classes.halfScoreFilling,
                            titleWrapper: classes.titleWrapper
                        }}
                        scoreMin={ scoreMin }
                        scoreMax={ scoreMax }
                        scoreValue={ scoreValue }
                        displayScore={ displayScore }
                        scoreBarConfig={ scoreBarConfig }
                        scoreName={ scoreName }
                        scoreBarType={ scoreBarType }
                        fill={ true }
                        languageId={ languageId }
                        developabilityLabel={ developabilityLabel }
                        developabilityScore={ developabilityScore }
                        developabilityDefinition={ developabilityDefinition }
                    />;
                    break;
            }
        }

        return (
            <div className={ `${style.scoreBlock} ${classes.scoreBlock}` }>
                { scoreBar }
                <div className={style.labelContainer}>
                    <p className={ classes.low } >{ lowLabel }</p>
                    <p className={ classes.high } >{ highLabel }</p>
                </div>
            </div>
        );
    }
}

AppendixScoreBarSection.propTypes = {
    scoreMin: PropTypes.number,
    scoreValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    scoreMax: PropTypes.number,
    lowLabel: PropTypes.string,
    highLabel: PropTypes.string,
    scoreBarConfig: PropTypes.object,
    scoreName: PropTypes.string,
    scoreBarType: PropTypes.oneOf([ScoreBarTypes.CROISSANT, ScoreBarTypes.NORMAL, ScoreBarTypes.BAR_GRAPH, ScoreBarTypes.GAUGE]),
    displayScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    classes: PropTypes.shape({
        root: PropTypes.string,
        barGraph: PropTypes.shape({
            root: PropTypes.string,
            fill: PropTypes.string,
            blank: PropTypes.string
        }),
        displayScore: PropTypes.string,
        categoryScore: PropTypes.string,
        titleWrapper: PropTypes.string,
        colors: PropTypes.object
    }),
    languageId: PropTypes.string,
    developabilityLabel: PropTypes.string,
    developabilityScore: PropTypes.string,
    developabilityDefinition: PropTypes.string,
    initials: PropTypes.string,
    levelRanges: PropTypes.array
};

AppendixScoreBarSection.defaultProps = {
    scoreMin: 0,
    scoreValue: 0,
    scoreMax: 0,
    lowLabel: '',
    highLabel: '',
    scoreBarConfig: {},
    scoreName: '',
    classes: {
        root: '',
        barGraph: {
            root: '',
            fill: '',
            blank: ''
        },
        halfScoreFilling: '',
        displayScore: '',
        categoryScore: '',
        titleWrapper: ''
    },
    languageId: '',
    developabilityLabel: '',
    developabilityScore: '',
    developabilityDefinition: ''
};
